import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import {
  Card,
  Stack,
  Container,
  Typography,
  CircularProgress,
  Box,
} from "@mui/material";
import Scrollbar from "../components/scrollbar";
import MegaspinsTable from "src/components/megaspins-table/MegaspinsTable";
import MegaspinDialog from "src/components/megaspins-table/MegaspinDialog";
import MegaspinSpecialChanceToggle from "src/components/megaspins-table/MegaspinSpecialChanceToggle";
import { get, put } from "src/utils/networkUtils";

export default function MegaspinsPage() {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState(null);
  const [megaspinEdit, setMegaspinEdit] = useState(null);
  const [specialChance, setSpecialChance] = useState(null);
  const [specialChanceUpdating, setSpecialChanceUpdating] = useState(false);

  useEffect(() => {
    get(`/admin/megaspins`).then(function (response) {
      setLoading(false);
      setRows(response.megaspinPeriods);
      setSpecialChance(response.specialChance ?? null);
    });
  }, []);

  const handleSaveSpecialChance = ({ enabled, percent }) => {
    setSpecialChanceUpdating(true);
    put(`/admin/megaspins/special-chance`, { enabled, percent })
      .then(function (response) {
        setSpecialChance(response.specialChance);
      })
      .finally(() => setSpecialChanceUpdating(false));
  };
  return (
    <>
      <Helmet>
        <title> Mega Spins </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Mega Spins
          </Typography>
        </Stack>

        <MegaspinSpecialChanceToggle
          specialChance={specialChance}
          onSave={handleSaveSpecialChance}
          isUpdating={specialChanceUpdating}
        />

        <Card>
          {rows === null || loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Scrollbar>
              <MegaspinsTable
                rows={rows}
                onEdit={setMegaspinEdit}
                specialChance={specialChance}
              />
            </Scrollbar>
          )}
        </Card>
      </Container>
      <MegaspinDialog
        open={megaspinEdit !== null}
        megaspin={megaspinEdit}
        onClose={() => setMegaspinEdit(null)}
        onSuccessHandler={() => {
          window.location.reload();
        }}
      />
    </>
  );
}
